<template>
  <div class="main-wrapper" ref="wrapper">
    <el-container>
      <el-header height="50px" style="line-height: 50px">
        <el-form :model="form" :inline="true" size="small">
          <el-form-item label="在产状态">
            <el-select v-model="form.packStatus" placeholder="请选择">
              <el-option
                v-for="item in packStatusOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="包件编码">
            <el-input v-model="form.packCode" placeholder="请输入包件编码" />
            <!-- <remote-select
              v-model="form.packCode"
              :requestMethod="data=>this.$q.preSalePlan.getPackCodeList({fragment: [data]})"
            >
            </remote-select> -->
          </el-form-item>
          <el-form-item label="包件名称">
            <el-input v-model="form.packName" placeholder="请输入包件编码" />
            <!-- <remote-select
              v-model="form.packName"
              :requestMethod="data=>this.$q.preSalePlan.getPackNameList({fragment: [data]})"
            >
            </remote-select> -->
          </el-form-item>
          <el-form-item style="float: right;">
            <el-button type="info" @click="edit" v-if="editStatus">完成</el-button>
            <el-button type="primary" @click="edit" v-else>编辑</el-button>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button type="warning" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </el-header>
    </el-container>
    <el-container>
      <el-main>
        <div style="margin-bottom: 10px;">
          <el-button type="primary" size="mini" @click="dataImport">导入</el-button>
        </div>
        <el-table
          border
          ref="table"
          :data="tableData"
          :height="tableHeight+'px'"
          v-loading="tableData === null"
          v-if="tableHeight"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" v-if="editStatus"></el-table-column>
          <el-table-column label="包件编码" prop="packCode"></el-table-column>
          <el-table-column label="包件名称" prop="packName"></el-table-column>
          <el-table-column label="在产状态" prop="packStatus">
            <template slot-scope="scope">
              <span v-if="selectionData.findIndex(v=>v.packCode === scope.row.packCode) === -1">{{scope.row.packStatus}}</span>
              <span v-else>
                <el-select v-model="scope.row.packStatus" placeholder="请选择" size="mini" @change="handlePackStatusChange(scope.row)">
                  <el-option
                    v-for="item in packStatusOptions2"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="更新日期" prop="updatedDate"></el-table-column>
        </el-table>
        <!-- pagination -->
        <div style="text-align: right; margin-top: 10px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js'
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [mixin, pagePathMixin],
  data() {
    return {
      form: {
        packStatus: '全部'
      },
      editStatus: false,
      tableData: null,
      selectionData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      tableHeight: 0
    }
  },
  computed: {
    packStatusOptions() {
      return [
        { name: '全部', value: '全部' },
        // { name: '未投产', value: '未投产' },
        { name: '退市', value: '退市' },
        { name: '预退市', value: '预退市' },
        // { name: '停销', value: '停销' },
        // { name: '在产', value: '在产' },
      ]
    },
    packStatusOptions2() {
      return [
        { name: '未投产', value: '未投产' },
        { name: '退市', value: '退市' },
        { name: '预退市', value: '预退市' },
        { name: '停销', value: '停销' },
        { name: '在产', value: '在产' },
      ]
    }
  },
  mounted() {
    this.tableHeight = this.$refs['wrapper'].offsetHeight - 178;
    this.init();
  },
  methods: {
    init() {
      let data = {
        filterData: {
          ...this.form
        },
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize
      };
      this.$q.preSalePlan.planPackStatus({data})
      .then(res=>{
        if(res.data && res.data.records) {
          this.tableData = res.data.records;
          this.paginationOpt.total = res.data.total;
        }else{
          this.tableData = [];
          this.paginationOpt.total = 0;
        }
      })
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    search() {
      this.paginationOpt.pageNum = 1;
      this.tableData = [];
      this.init();
    },
    reset() {
      this.form = {
        packStatus: '全部',
        packCode: '',
        packName: '',
      };
      this.paginationOpt.pageNum = 1;
      this.tableData = [];
      this.$nextTick(_=>{
        this.init();
      })
    },
    dataImport() {
      this.openSubPage({
        path: '/dataImport/productingPackageStatus',
        query: {
          // fileType: Global.FILE_TYPE['包件在产状态'],
          fileName: '包件在产状态.xlsx',
          appCode: 'ec-pc-new'
        }
      })
    },
    // 编辑
    edit() {
      this.init();
      this.editStatus = !this.editStatus;
      this.selectionData = [];
      this.$refs['table'].clearSelection();
    },
    // change
    handleSelectionChange(data) {
      this.selectionData = data;
    },
    // change在产状态
    handlePackStatusChange({packCode, packName, packStatus}) {
      this.$q.preSalePlan.batchUpdatePackStatus({data: [
        {packCode, packName, packStatus}
      ]})
      .then(res=>{
        res.code == 200 && this.$message.success('编辑成功')
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .main-wrapper
    height calc(100vh - 85px)
    padding 10px
    box-sizing border-box

  >>> .el-container
    background #ffffff

  >>> .el-main
    padding 10px

  >>> .el-container+.el-container
    margin-top 10px

  >>>.el-date-editor.el-input, >>>.el-date-editor.el-input__inner
    width 140px

  >>> .el-form-item--small.el-form-item
    margin-bottom 0px

  >>> .el-form-item--small .el-form-item__content
    line-height 50px
</style>